import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { InfoMessage } from 'components';
import { compareRunDates } from 'utils/data-validation';
import styled from 'styled-components/macro';
import { RuleRunStatus } from 'types/dt-graphql-apollo-v2';
import { PAGINATION_PAGE_SIZE } from 'utils/config';

type RuleHistoryProps = {
  ruleRuns: RuleRunStatus[] | null;
};

export const RuleHistory = ({ ruleRuns }: RuleHistoryProps) => {
  if (!ruleRuns || ruleRuns.length === 0) {
    return <InfoMessage type="FloatNone" title="No history available." />;
  }

  const columns: ColumnsType<RuleRunStatus> = [
    {
      title: 'Run time',
      key: 'runAt',
      sorter: (a, b) => compareRunDates(a, b),
      render: (record: RuleRunStatus) =>
        (record?.runAt &&
          new Date(record?.runAt?.toString()).toLocaleDateString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
          })) ||
        '-',
    },
    {
      title: 'Failed tags (#)',
      key: 'failedTags',
      sorter: (a, b) => (a.totalFailed || 0) - (b.totalFailed || 0),
      render: (record: RuleRunStatus) => record.totalFailed || 0,
    },
  ];

  return (
    <StyledTable>
      <Table
        rowKey="id"
        dataSource={ruleRuns}
        columns={columns}
        pagination={{
          defaultPageSize: PAGINATION_PAGE_SIZE,
          hideOnSinglePage: true,
        }}
      />
    </StyledTable>
  );
};

const StyledTable = styled.div`
  padding: 1rem 0;
  .ant-table {
    background: transparent;
  }
  table {
    border-spacing: 0 4px;
  }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 10px 16px;
  }
  .ant-table-thead {
    > tr > th {
      border-bottom: none;
      background: transparent;
    }
  }
  .ant-table-row {
    background: var(--cogs-white);
    box-shadow: var(--cogs-z-4);
    cursor: pointer;
  }
  .anticon.ant-table-column-sorter-up,
  .anticon.ant-table-column-sorter-down {
    &.active {
      color: var(--cogs-text-primary);
    }
  }
`;
